import { SlideItemType, AssetType } from '@/utils/types/enums';

import { SlideItem, Asset } from '../types';
import { getAssetsByRefs } from './asset-loader';

export interface ResolvedItemAssets {
  assets: Asset[];
  title: string;
}

/**
 * Resolves assets and title for any slide item type
 *
 * @param item - The slide item to resolve
 * @param allAssets - All available assets in the case
 * @param itemIndex - Index of the item (used for fallback IDs)
 * @returns Object containing resolved assets array and title string
 */
export const resolveItemAssets = (
  item: SlideItem,
  allAssets: Asset[],
  itemIndex: number
): ResolvedItemAssets => {
  if (item.type === SlideItemType.INFO) {
    return {
      assets: getAssetsByRefs(item.assetRefs, allAssets),
      title: item.title || '',
    };
  }

  if (item.type === SlideItemType.IMAGE) {
    return {
      assets: [
        {
          id: `img-${itemIndex}`,
          path: item.url,
          title: item.alt,
          type: AssetType.IMAGE,
        },
      ],
      title: item.alt,
    };
  }

  // Unsupported type
  return {
    assets: [],
    title: '',
  };
};
